import { LoadingDots, SectionHeader } from '@flos/react-ui';
import LandingBackButton from '../../../LandingPage/components/LandingBackButton';
import CoverageDetailBoxComponent from '../CoverageDetailBox/CoverageDetailBox';
import { useRecoilValue } from 'recoil';
import { getExistingCoveragesSelector } from '../../../../recoil/selectors/getExistingCoveragesSelector';
import { coverageTermsSelector } from '../../../../recoil/selectors/coverageTermsSelector';
import { type CoverageOpcDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import { useHippoText } from '../../../../hooks/useHippoText';
import usePageNavigation from '../../../../hooks/usePageNavigation';
import { opcInfoAtom } from '../../../../recoil/atoms/opcInfoAtom';
import { isOpcFetchingAtom } from '../../../../recoil/atoms/isOpcFetchingAtom';
import useOpcJob from '../../../../hooks/useOpcJob';

const ExistingCoverageComponent = ({
    onOpenModal
}: {
    onOpenModal: () => void;
}): React.JSX.Element => {
    const coverageTextItems = useRecoilValue(coverageTermsSelector);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const getHippoText = useHippoText();
    const { isFromDAFlow } = useRecoilValue(opcInfoAtom);
    const selectedCoverages: CoverageOpcDTO[] = useRecoilValue(getExistingCoveragesSelector);
    const handleOpenModal = (): void => {
        onOpenModal();
    };
    const { goBackToDetailsPage, goToShoppingBasket } = usePageNavigation();
    const { withdrawCurrentOPCShoppingBasketIfNotExisting } = useOpcJob();

    if (isOpcFetching) {
        return <LoadingDots centered />;
    }

    const handleLandingBackBtnClick = async (): Promise<void> => {
        if (isFromDAFlow) {
            goToShoppingBasket();
            return;
        }

        await withdrawCurrentOPCShoppingBasketIfNotExisting();
        goBackToDetailsPage();
    };

    return (
        <>
            <LandingBackButton
                isFromMitTopdanmark={true}
                handleClick={() => {
                    void handleLandingBackBtnClick();
                }}
            />
            <SectionHeader
                className="u-spacing-inset-top-11"
                title={getHippoText('DSS-COVERABLE-DETAILS-CUSTOM-COVERAGE')}
            />
            {selectedCoverages && (
                <div className="u-flex-box u-flex-box--col" id="coverageListAccordionSubSection">
                    {selectedCoverages.map((coverage) => {
                        if (!coverage.terms) {
                            return <></>;
                        }
                        const coverageTextItem = coverageTextItems?.find(
                            (covText) => covText.coverageItemId === coverage.type
                        );
                        return (
                            <CoverageDetailBoxComponent
                                key={coverage.name}
                                coverage={coverage}
                                coverageContent={coverageTextItem}
                                onOpenModal={handleOpenModal}
                            ></CoverageDetailBoxComponent>
                        );
                    })}
                </div>
            )}
        </>
    );
};

export default ExistingCoverageComponent;
